<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="row">
            <div class="col-8">
              <div class="card-header pb-0">
                <h6>Pengumuman</h6>
                <p class="text-xs text-secondary mb-0">
                  Pengumuman di sini otomatis tampil dan dikirim sebagai notifikasi ke aplikasi mobile semua karyawan.
                </p>
              </div>
            </div>
            <div class="col-4 float-right">
              <argon-button
                class="mt-4"
                variant="gradient"
                color="success"
                size="sm"
                @click="create()"
              ><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Buat Pengumuman</argon-button>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2 mt-4">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">No.</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder"></th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder">Pengumuman</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder">Dibuat Oleh</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Tanggal</th>
                    <th class="text-secondary"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in table.data" :key="i">
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold">{{ i + 1 }}</span>
                    </td>
                    <td class="align-middle text-sm">
                      <img v-if="row.gambar" :src="apiUrl+'pengumuman/gambar/'+row.id" style="width: 56px; height: 56px; object-fit: cover; border-radius: 10px;">
                      <div v-else class="d-flex align-items-center justify-content-center" style="width: 56px; height: 56px; border-radius: 10px; background-color: #F0F2F5;">
                        <i class="fa fa-bullhorn text-secondary" aria-hidden="true"></i>
                      </div>
                    </td>
                    <td class="align-middle text-sm" style="max-width: 360px;">
                      <h6 class="mb-0 text-sm">{{ row.judul }}</h6>
                      <span class="text-secondary text-xs">{{ truncate(row.isi, 120) }}</span>
                    </td>
                    <td class="align-middle text-sm">
                      <span class="badge badge-sm bg-gradient-secondary">{{ row.created_by || '-' }}</span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold d-block">{{ formatTanggal(row.created_at) }}</span>
                      <span class="text-secondary text-xs">{{ moment(row.created_at).locale('id').format('HH:mm') }}</span>
                    </td>
                    <td class="align-middle text-end">
                      <i class="fas fa-edit fa-sm" aria-hidden="true" style="cursor: pointer; margin-right: 20px;" @click="edit(row)" title="Edit"></i>
                      <i class="fas fa-trash fa-sm" aria-hidden="true" title="Hapus" style="cursor: pointer; margin-right: 20px;" @click="remove(row.id)"></i>
                    </td>
                  </tr>
                  <tr v-if="table.data.length === 0">
                    <td colspan="6" class="text-center text-sm text-secondary py-5">
                      <i class="fa fa-bullhorn fa-2x text-secondary mb-2" aria-hidden="true" style="opacity: 0.4;"></i>
                      <br>Belum ada pengumuman.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- =======  MODAL ADD/EDIT ======= -->
  <div class="container">
    <vue-final-modal v-model="form.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{ form.title }}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="form.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label class="form-control-label mt-3">Judul <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Judul pengumuman" v-model="dataPengumuman.judul" required>

        <label class="form-control-label mt-3">Isi <span style="color: red;">*</span></label>
        <textarea class="form-control" rows="5" placeholder="Isi pengumuman" v-model="dataPengumuman.isi" required></textarea>

        <label class="form-control-label mt-3">Gambar (opsional)</label>
        <input type="file" class="form-control" accept="image/*" @change="filesChange">
        <img v-if="form.title == 'Edit Data' && dataPengumuman.gambar" :src="apiUrl+'pengumuman/gambar/'+dataPengumuman.id" style="max-width: 200px; margin-top: 10px; border-radius: 8px;">

        <p class="text-xs text-secondary mt-3 mb-0" v-if="form.title == 'Add Data'">
          <i class="fa fa-info-circle" aria-hidden="true"></i> Notifikasi otomatis terkirim ke semua karyawan saat disimpan.
        </p>
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"></div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button variant="gradient" color="secondary" size="sm" width="1" @click="form.show = false">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="save()">Save</argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import Api from '@/helpers/api';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import pengumuman from '@/services/pengumuman.service';
import akun from '@/services/akun.service';
import config from '@/configs/config';
import moment from 'moment';

export default {
  name: "pengumuman",
  components: {
    ArgonButton,
    VueFinalModal,
  },
  data() {
    return {
      table: {
        data: []
      },
      form: {
        title: "Add Data",
        show: false
      },
      dataPengumuman: {},
      role: '',
      apiUrl: config.apiUrl,
    };
  },
  mounted() {
    this.get();
    this.getRole();
  },
  methods: {
    moment,
    truncate(text, length) {
      if (!text) return '';
      return text.length > length ? text.substring(0, length) + '...' : text;
    },
    formatTanggal(value) {
      // e.g. "27 Januari 2026" -- moment's 'LL' format in the 'id' locale
      // renders exactly this, so it stays correct if the locale's month
      // names/ordering ever change instead of hand-building the string.
      return moment(value).locale('id').format('D MMMM YYYY');
    },
    get() {
      let context = this;
      Api(context, pengumuman.index()).onSuccess(function(response) {
        context.table.data = response.data.data;
      }).onError(function(error) {
        if (error.response && error.response.status == 404) {
          context.table.data = [];
        } else {
          context.notify('Gagal memuat data pengumuman', 'error')
        }
      })
      .call()
    },
    getRole() {
      let context = this;
      Api(context, akun.indexProfile()).onSuccess(function(response) {
        context.role = response.data.data[0].role;
        if (response.data.data[0].role != 'Admin') {
          context.$router.push({ path: '/detail-profile/'+response.data.data[0].employee_id})
        }
      }).onError(function(error) {})
      .call()
    },
    filesChange(e) {
      this.dataPengumuman.gambar = e.target.files[0];
    },
    create() {
      this.form.show  = true;
      this.form.title = "Add Data";
      this.dataPengumuman = {};
    },
    edit(row) {
      this.dataPengumuman = { ...row };
      this.form.show  = true;
      this.form.title = 'Edit Data';
    },
    save() {
      let api      = null;
      let context  = this;
      let formData = new FormData();

      if (context.dataPengumuman.judul && context.dataPengumuman.isi) {
        formData.append('judul', context.dataPengumuman.judul);
        formData.append('isi', context.dataPengumuman.isi);
        // Only a freshly-picked File object should be uploaded -- the
        // existing filename string (set when editing) isn't a real upload.
        if (context.dataPengumuman.gambar instanceof File) {
          formData.append('gambar', context.dataPengumuman.gambar);
        }
      } else {
        return alert('Field Bintang Merah Wajib Di Isi')
      }

      if (context.form.title == 'Add Data') {
        api = Api(context, pengumuman.create(formData));
      } else {
        api = Api(context, pengumuman.update(context.dataPengumuman.id, formData));
      }
      api.onSuccess(function() {
        context.get();
        context.form.show = false;
        context.notify(context.form.title == 'Add Data' ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      }).onError(function() {
        context.notify('Data Gagal di Simpan', 'error')
      })
      .call();
    },
    remove(id) {
      var r = confirm("Anda yakin ingin menghapus pengumuman ini ?");
      if (r == true) {
        let context = this;
        Api(context, pengumuman.delete(id)).onSuccess(function() {
          context.get();
          context.notify('Data Successfully Deleted', 'success')
        }).onError(function() {
          context.notify('Gagal menghapus pengumuman', 'error')
        }).call();
      }
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, { autoClose: 2000 });
      } else {
        toast.error(message, { autoClose: 2000 });
      }
    },
  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>
